export const FADE_MIN = 0.2
export const FADE_MAX = 0.5
export const FADE_DEFAULT = 0.3
export const FADE_STEP = 0.1
const DEFAULT_AUDIO_TRACK_ID = (import.meta as any).env.VITE_DEFAULT_AUDIO_TRACK || 'COMMENTARY'
export const DEFAULT_AUDIO_TRACK = {id: DEFAULT_AUDIO_TRACK_ID, value: DEFAULT_AUDIO_TRACK_ID}